import { Heart, RefreshCcw } from "lucide-react";
import { useState } from "react";
import { verses } from "@/content";
import { Reveal } from "@/components/Reveal";

export default function SOSWidget() {
  const [index, setIndex] = useState(0);
  const verse = verses[index];
  return (
    <section className="section sos-section" data-testid="sos-prayer-widget-box">
      <div className="section-shell sos-panel">
        <Reveal className="sos-mark"><Heart size={21} /></Reveal>
        <Reveal className="sos-copy" delay={70}><p className="eyebrow">SE O IMPULSO ESTÁ ACONTECENDO AGORA</p><h2>Faça uma pausa de três minutos.</h2><p>Coloque os dois pés no chão. Respire mais devagar. Leia em voz baixa. Depois, mande uma mensagem para uma pessoa segura antes de abrir qualquer aplicativo.</p></Reveal>
        <Reveal className="sos-verse" delay={130}><span className="verse-reference">{verse.reference}</span><p data-testid="sos-verse-display">“{verse.text}”</p><button type="button" className="verse-refresh" onClick={() => setIndex((index + 1) % verses.length)} data-testid="sos-refresh-verse-button"><RefreshCcw size={15} /> outro versículo</button></Reveal>
      </div>
    </section>
  );
}
